import * as React from 'react';

export const OutboundDirectionIcon: React.FunctionComponent = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 13 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.93935 3.81804H9.18199V8.06068"
      stroke="#7A7A7A"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.82849 4.17157L2.81808 10.182"
      stroke="#7A7A7A"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
